import { createReactComponent } from '@tabler/icons-react';

export const IconCustomSplitDone = createReactComponent(
  'outline',
  'customSplitDone',
  'CustomSplitDone',
  [
    [
      'path',
      {
        key: 'customSplitDone-path',
        d: 'M8.60001 8.59998L15.1561 15.156M8.60001 15.4L19.0001 5M13.7999 18.9999L15.8 20.9999L19.8 16.9999M2.99987 7C2.99987 7.79565 3.31595 8.55871 3.87856 9.12132C4.44117 9.68393 5.20424 10 5.99989 10C6.79555 10 7.55861 9.68393 8.12123 9.12132C8.68384 8.55871 8.99991 7.79565 8.99991 7C8.99991 6.20435 8.68384 5.44129 8.12123 4.87868C7.55861 4.31607 6.79555 4 5.99989 4C5.20424 4 4.44117 4.31607 3.87856 4.87868C3.31595 5.44129 2.99987 6.20435 2.99987 7ZM2.99987 17C2.99987 17.7956 3.31595 18.5587 3.87856 19.1213C4.44117 19.6839 5.20424 20 5.99989 20C6.79555 20 7.55861 19.6839 8.12123 19.1213C8.68384 18.5587 8.99991 17.7956 8.99991 17C8.99991 16.2044 8.68384 15.4413 8.12123 14.8787C7.55861 14.3161 6.79555 14 5.99989 14C5.20424 14 4.44117 14.3161 3.87856 14.8787C3.31595 15.4413 2.99987 16.2044 2.99987 17Z',
      },
    ],
  ]
);
